import { Model } from '@vuex-orm/core'

export default class Message extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'messages'

  static primaryKey = '_id'

  // List of all fields (schema) of the message model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      channel_type: this.attr(null),
      sender_user_id: this.attr(null),
      type: this.attr(null),
      content: this.attr(null),
      attachment_media_ids: this.attr([]),
      delivery_status: this.attr(null),
      // why the provider refused the message: { code, message }, null when it went out
      delivery_error: this.attr(null),
      sent_at: this.attr(null),
      account_id: this.attr(null),
      connection_id: this.attr(null),
      conversation_id: this.attr(null),
      channel_address: this.attr(null),
      contact_address: this.attr(null),
      direction: this.attr(null),
      metadata: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Message.js